import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const BuyVehicles = ({ title }) => {
  const vehicleInfo = (
    <>
      <p>
        The <strong>2nd Motor Vehicles Market</strong> is a platform where users can search for <strong>second-hand motor vehicles</strong> according to their needs and budget.
      </p>
      <p>
        This marketplace supports both <strong>B2B (Business-to-Business)</strong> and <strong>B2C (Business-to-Consumer)</strong> transactions. Vehicle dealers and businesses can list used vehicles, while individual consumers can browse, compare, and purchase vehicles from businesses or other sellers.
      </p>
      <p>
        The platform makes it easy to find reliable second-hand vehicles by providing <strong>multiple options, transparent listings, and convenient access</strong> for buyers and sellers alike.
      </p>

           <a href="https://www.youtube.com" target="_blank">
  <strong>Click here to see how to Explore the Market</strong>
</a>
    </>
  );

  return (
    <div>
      <Row>
        <Col lg="12">
          {/* CardNav displays title + full vehicle info */}
          <CardNav Header={title} myid={1} myinfo={vehicleInfo} />

          {/* BoxData for Buy Vehicles */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="Vehicles For Sale"
              Butonn="Search Now"
              imgg={images.BuyVehicles}
              link="/buy-used-cars"
              buy="sixteen"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default BuyVehicles;
